// ModalForm.jsx

import React from 'react';

// CSS
import './ModalForm.css';

/**
 * ModalForm
 * 
 * A simple form component for modals.
 *  
 *
 * @param {string} height - The height of the form.
 * @param {string} gap - The gap between form elements.
 * @param {string} children - The children to display inside the form.
 * 
 * @returns {ReactNode} - ModalForm.
 */
const ModalForm = React.memo(({ height = 'auto', gap = '24px', width = '100%', containScroll = false, children }) => {

    // ----- RENDER ----- //

    return (

        <div
          className={`modal-form-container${containScroll ? ' modal-form-container-contained' : ''}`}
          style={{
            gap: gap,
            height: height,
            width: width,
          }}
        >
            {children}
        </div>
    );

});

// Dev Tools
ModalForm.displayName = 'ModalForm';

export default ModalForm;
